import { Component, OnDestroy, OnInit } from '@angular/core';
import { uiHelper } from '~/helpers/ui.helper';
import { translationHelper } from '~/helpers/translation.helper';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { CoreService } from '~/legacy/ts/services/core.service';

declare let $;

@Component({
    selector: 'comp-slip-duplicate-modal',
    templateUrl: './slip-duplicate-modal.html',
})
export class SlipDuplicateModal implements OnInit, OnDestroy {
    constructor(
        private _uiHelper: uiHelper,
        public translate: translationHelper,
        public tournamentsService: TournamentsService,
        public coreService: CoreService,
    ) {}

    ngOnInit() {}

    ngAfterViewInit() {}

    modalHide() {
        $('#Slip_Duplicate_Modal').modal('hide');
    }

    ngOnDestroy() {}

    getSlipDuplicate(slipId = 0) {}
}
